import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const newPickerActions = {
  FETCH_PICKER_ORDER_DATA_SUCCESS: "FETCH_PICKER_ORDER_DATA_SUCCESS",
  FETCH_PICKER_ORDER_DATA_FAILURE: "FETCH_PICKER_ORDER_DATA_FAILURE",
  FETCH_SCANNED_PICKER_ORDER_DATA_SUCCESS:
    "FETCH_SCANNED_PICKER_ORDER_DATA_SUCCESS",
  FETCH_SCANNED_PICKER_ORDER_DATA_FAILURE:
    "FETCH_SCANNED_PICKER_ORDER_DATA_FAILURE",
  SAVE_MISSING_MEDS_SUCCESS: "SAVE_MISSING_MEDS_SUCCESS",
  SAVE_MISSING_MEDS_FAILURE: "SAVE_MISSING_MEDS_FAILURE",
  CLEAR_PICKER_ORDER_DATA: "CLEAR_PICKER_ORDER_DATA",
  VALIDATE_ORDER_ASSIGN_PICKER_SUCCESS: "VALIDATE_ORDER_ASSIGN_PICKER_SUCCESS",
  VALIDATE_ORDER_ASSIGN_PICKER_FAILURE: "VALIDATE_ORDER_ASSIGN_PICKER_FAILURE",
};

////////////////////////////////////////////////
//? To get order data for picker
////////////////////////////////////////////////

export function getPickerOrderDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newPickerActions.FETCH_PICKER_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function getPickerOrderDetailsError(error) {
  return {
    type: newPickerActions.FETCH_PICKER_ORDER_DATA_FAILURE,
    payload: error,
  };
}

export function getPickerOrderDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/getOrderFromPoolForPicker?warehouseId=${props.warehouseId}`;
  return makeApiCall(
    getUrl,
    getPickerOrderDetailsSuccess,
    getPickerOrderDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

////////////////////////////////////////////////
//? To get order data for picker after scanning
////////////////////////////////////////////////

export function getScannedPickerOrderDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newPickerActions.FETCH_SCANNED_PICKER_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function getScannedPickerOrderDetailsError(error) {
  return {
    type: newPickerActions.FETCH_SCANNED_PICKER_ORDER_DATA_FAILURE,
    payload: error,
  };
}

export function getScannedPickerOrderDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/getOrderDetailForPickerPwa?orderId=${
    props.orderId
  }&warehouseId=${props.warehouseId}&isNewFlow=${true}&isOrderAssigned=${
    props.isOrderAssigned ? true : false
  }`;
  return makeApiCall(
    getUrl,
    getScannedPickerOrderDetailsSuccess,
    getScannedPickerOrderDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

////////////////////////////////////////////////
//? To save missing med for picker
////////////////////////////////////////////////

export function savePickerMissingMedicineSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newPickerActions.SAVE_MISSING_MEDS_SUCCESS,
      payload: props,
    });
  };
}

export function savePickerMissingMedicineError(error) {
  return {
    type: newPickerActions.SAVE_MISSING_MEDS_FAILURE,
    payload: error,
  };
}

export function savePickerMissingMedicineDetails(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/saveMissingMedicineDetailsForPicker?lastMed=${
    props.lastMed ? props.lastMed : false
  }`;
  return makeApiCall(
    postUrl,
    savePickerMissingMedicineSuccess,
    savePickerMissingMedicineError,
    "POST",
    props.missingMedicineDetailsList,
    reqHeader,
    props.history
  );
}

////////////////////////////////////////////////
//? Clear Picker order data
////////////////////////////////////////////////

export function clearPickerDetails() {
  return (dispatch) => {
    dispatch({
      type: newPickerActions.CLEAR_PICKER_ORDER_DATA,
      payload: "",
    });
  };
}

// export function validateOrderAssignPickerSuccess(props) {
//   return (dispatch) => {
//     dispatch({
//       type: newPickerActions.VALIDATE_ORDER_ASSIGN_PICKER_SUCCESS,
//       payload: props,
//     });
//   };
// }

// export function validateOrderAssignPickerError(error) {
//   return {
//     type: newPickerActions.VALIDATE_ORDER_ASSIGN_PICKER_FAILURE,
//     payload: error,
//   };
// }

// export function validateOrderAssignPickerThunk(props) {
//   const reqHeader = {
//     "Content-Type": "application/json",
//     Authorization: "Bearer " + props.access_token,
//   };
//   const postUrl = `${AdminService_URL}/validateOrderAssignPicker?orderId=${props.orderId}`;
//   return makeApiCall(
//     postUrl,
//     validateOrderAssignPickerSuccess,
//     validateOrderAssignPickerError,
//     "GET",
//     null,
//     reqHeader,
//     props.history
//   );
// }
